// src\constants\skills-svgs.constants.js

export const BASE_SVG_URL = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/';

// Javascript
export const JS_SVG = 'javascript/javascript-original.svg';
export const JS_SVG_ALT = 'javascript';
export const JS_SVG_HREF = 'https://www.javascript.com/';

// Typescript
export const TS_SVG = 'typescript/typescript-original.svg';
export const TS_SVG_ALT = 'typescript';
export const TS_SVG_HREF = 'https://www.typescriptlang.org/';

// ReactJS
export const REACTJS_SVG = 'react/react-original-wordmark.svg';
export const REACTJS_ALT = 'react';
export const REACTJS_HREF = 'https://reactjs.org/';

// NodeJS
export const NODEJS_SVG = 'nodejs/nodejs-original-wordmark.svg';
export const NODEJS_ALT = 'nodejs';
export const NODEJS_HREF = 'https://nodejs.org/';

// HTML5
export const HTML5_SVG = 'html5/html5-original-wordmark.svg';
export const HTML5_ALT = 'html5';
export const HTML5_HREF = 'https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5';

// CSS3
export const CSS3_SVG = 'css3/css3-original-wordmark.svg';
export const CSS3_ALT = 'css3';
export const CSS3_HREF = 'https://developer.mozilla.org/en-US/docs/Glossary/CSS';

// ExpressJS
export const EXPRESS_SVG = 'express/express-original-wordmark.svg';
export const EXPRESS_ALT = 'express';
export const EXPRESS_HREF = 'https://expressjs.com/';

// Sass
export const SASS_SVG = 'sass/sass-original.svg';
export const SASS_ALT = 'sass';
export const SASS_HREF = 'https://sass-lang.com/';

// NestJS
export const NESTJS_SVG = 'nestjs/nestjs-line-wordmark.svg';
export const NESTJS_ALT = 'nestjs';
export const NESTJS_HREF = 'https://nestjs.com/';

// NextJS
export const NEXTJS_SVG = 'nextjs/nextjs-line-wordmark.svg';
export const NEXTJS_ALT = 'nextjs';
export const NEXTJS_HREF = 'https://nextjs.org/';

// MongoDB
export const MONGODB_SVG = 'mongodb/mongodb-original-wordmark.svg';
export const MONGODB_ALT = 'mongodb';
export const MONGODB_HREF = 'https://www.mongodb.com/';

// PostgreSQL
export const POSTGRESQL_SVG = 'postgresql/postgresql-original-wordmark.svg';
export const POSTGRESQL_ALT = 'postgresql';
export const POSTGRESQL_HREF = 'https://www.postgresql.org/';

// ElectronJS
export const ELECTRONJS_SVG = 'electron/electron-original-wordmark.svg';
export const ELECTRONJS_ALT = 'electron';
export const ELECTRONJS_HREF = 'https://www.electronjs.org/';

// Redux
export const REDUX_SVG = 'redux/redux-original.svg';
export const REDUX_ALT = 'redux';
export const REDUX_HREF = 'https://redux.js.org/';

// AWS
export const AWS_SVG = 'amazonwebservices/amazonwebservices-original-wordmark.svg';
export const AWS_ALT = 'amazonwebservices';
export const AWS_HREF = 'https://aws.amazon.com/';

// Docker
export const DOCKER_SVG = 'docker/docker-original-wordmark.svg';
export const DOCKER_ALT = 'docker';
export const DOCKER_HREF = 'https://www.docker.com/';

// Git
export const GIT_SVG = 'git/git-original-wordmark.svg';
export const GIT_ALT = 'git';
export const GIT_HREF = 'https://www.git-scm.com/';

// Bootstrap
export const BOOTSTRAP_SVG = 'bootstrap/bootstrap-original-wordmark.svg';
export const BOOTSTRAP_ALT = 'bootstrap';
export const BOOTSTRAP_HREF = 'https://getbootstrap.com/';

// Materia UI
export const MUI_SVG = 'materialui/materialui-original.svg';
export const MUI_ALT = 'materialui';
export const MUI_HREF = 'https://mui.com/';

// Ant Design
export const ANTD_SVG = 'antdesign/antdesign-original-wordmark.svg';
export const ANTD_ALT = 'antdesign';
export const ANTD_HREF = 'https://ant.design/';

// GRPC
export const GRPC_SVG = 'grpc/grpc-plain.svg';
export const GRPC_ALT = 'grpc';
export const GRPC_HREF = 'https://grpc.io/';

export const SKILLS_SVG = [
  {
    svg: JS_SVG,
    alt: JS_SVG_ALT,
    href: JS_SVG_HREF,
  },
  {
    svg: TS_SVG,
    alt: TS_SVG_ALT,
    href: TS_SVG_HREF,
  },
  {
    svg: REACTJS_SVG,
    alt: REACTJS_ALT,
    href: REACTJS_HREF,
  },
  {
    svg: NODEJS_SVG,
    alt: NODEJS_ALT,
    href: NODEJS_HREF,
  },
  {
    svg: HTML5_SVG,
    alt: HTML5_ALT,
    href: HTML5_HREF,
  },
  {
    svg: CSS3_SVG,
    alt: CSS3_ALT,
    href: CSS3_HREF,
  },
  {
    svg: SASS_SVG,
    alt: SASS_ALT,
    href: SASS_HREF,
  },
  {
    svg: EXPRESS_SVG,
    alt: EXPRESS_ALT,
    href: EXPRESS_HREF,
  },
  {
    svg: NESTJS_SVG,
    alt: NESTJS_ALT,
    href: NESTJS_HREF,
  },
  {
    svg: NEXTJS_SVG,
    alt: NEXTJS_ALT,
    href: NEXTJS_HREF,
  },
  {
    svg: ELECTRONJS_SVG,
    alt: ELECTRONJS_ALT,
    href: ELECTRONJS_HREF,
  },
  {
    svg: REDUX_SVG,
    alt: REDUX_ALT,
    href: REACTJS_HREF,
  },
  {
    svg: MONGODB_SVG,
    alt: MONGODB_ALT,
    href: MONGODB_HREF,
  },
  {
    svg: POSTGRESQL_SVG,
    alt: POSTGRESQL_ALT,
    href: POSTGRESQL_HREF,
  },
  {
    svg: BOOTSTRAP_SVG,
    alt: BOOTSTRAP_ALT,
    href: BOOTSTRAP_HREF,
  },
  {
    svg: MUI_SVG,
    alt: MUI_ALT,
    href: MUI_HREF,
  },
  {
    svg: ANTD_SVG,
    alt: ANTD_ALT,
    href: ANTD_HREF,
  },
  {
    svg: GIT_SVG,
    alt: GIT_ALT,
    href: GIT_HREF,
  },
  {
    svg: GRPC_SVG,
    alt: GRPC_ALT,
    href: GRPC_HREF,
  },
  {
    svg: DOCKER_SVG,
    alt: DOCKER_ALT,
    href: DOCKER_HREF,
  },
  {
    svg: AWS_SVG,
    alt: AWS_ALT,
    href: AWS_HREF,
  },
];
